import { createStrings } from '@utils/local';
import type { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: '進行中の案件(出港前)',
  },
});

export const meta: PageMeta = {
  title: strings.title,
  order: 2,
  staffOnly: true,
};
